import React, { useState } from 'react';
import { Layout } from 'antd';
import Sidebar from '../sidebar/Sidebar';
import Navbar from '../navbar/Navbar';
import LoadingBox from '../loading/LoadingBox';
import { useIsTablet } from '../../hooks/useIsTablet';

interface AppLayoutProps {
    children: React.ReactNode;
    title: string;
    loading?: boolean;
    footer?: React.ReactNode;
    onBackNavigation?: () => void;
    showBackButton?: boolean;
}

const AppLayout: React.FC<AppLayoutProps> = ({ title, children, footer, loading = false, onBackNavigation, showBackButton = false }) => {
    // Lire l'état initial du localStorage ou définir comme non rétracté (false)
    const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(() => {
        const savedState = localStorage.getItem('isSidebarCollapsed');
        return savedState === 'true';
    });
    const isTablet = useIsTablet();
    
    const [fromToggle, setFromToggle] = useState(false);
    
    // Fonction pour basculer la largeur du Sidebar
    const toggleSidebar = () => {
        const newCollapsedState = !isSidebarCollapsed;
        setIsSidebarCollapsed(newCollapsedState);
        localStorage.setItem('isSidebarCollapsed', String(newCollapsedState));

        setFromToggle(true);
    };

    return (
        <Layout style={{ minHeight: '100vh', display: 'flex' }}>
            {/* Passer l'état et la fonction de bascule au Sidebar */}

            {(isSidebarCollapsed && isTablet) ? (
                // Si la sidebar est repliée et qu'on est sur tablette, ne rien afficher
                <>  </>
            ) : (
                 // Sinon, afficher la sidebar avec son état
                 <Sidebar 
                    isCollapsed={isSidebarCollapsed} 
                    onToggleSidebar={toggleSidebar} 
                    fromToggle={fromToggle}
                    setFromToggle={setFromToggle}
                />
            )}

            <Layout
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    flexGrow: 1,
                    marginLeft: (isTablet && isSidebarCollapsed) ? '0px' : (isSidebarCollapsed ? '80px' : '250px'),
                    transition: 'margin-left 0.3s ease',  // Transition douce lors du changement de largeur
                }}
            >
                {
                    (isTablet && !isSidebarCollapsed) ? (
                        // Si la sidebar est affichée et qu'on est sur tablette, ne pas afficher la navbar
                        <>  </>
                    ) : (
                        /* Passer les props au Navbar */
                        <Navbar title={title} onBackNavigation={onBackNavigation} showBackButton={showBackButton} isCollapsed={isSidebarCollapsed} onToggleSidebar={toggleSidebar} />
                    )
                }

                <Layout.Content style={{ flexGrow: 1, padding: '24px', background: '#f0f2f5' }}>
                    {loading ? (
                        < LoadingBox />
                    ) : (
                        children
                    )}
                </Layout.Content>

                {footer && (
                    <Layout.Footer style={{ background: '#fff', padding: '16px 24px' }}>
                        {footer}
                    </Layout.Footer>
                )}
            </Layout>
        </Layout>
    );
};

export default AppLayout;
